import type {TextureType} from "#material/types/texture"
import {materialConnection} from "#material/nodes/base/connection/shorthand"
import {TexImage} from "#material/nodes/texture/tex-image/tex-image"
import {Mapping} from "#material/nodes/vector/mapping/mapping"
import type {InputMaterialConnection, OutputMaterialConnection} from "#material/sockets/definition"

export function createMappingNode(
    uvNode: InputMaterialConnection<"point"> | undefined,
    scale: [number, number, number] = [1, 1, 1],
    rotation: [number, number, number] = [0, 0, 0],
    location: [number, number, number] = [0, 0, 0],
) {
    return new Mapping({
        parameters: {
            inputs: {
                vector: uvNode,
            },
            settings: {
                vectorType: "TEXTURE",
                location: {x: location[0], y: location[1], z: location[2]},
                rotation: {x: rotation[0], y: rotation[1], z: rotation[2]},
                scale: {x: scale[0], y: scale[1], z: scale[2]},
            },
        },
    })
}

export function createTexImageNodeForNodeImageResource(
    textureSetRevisionId: string,
    mapAssignments: {textureType: TextureType; legacyId: number; id: string}[],
    slot: TextureType,
    mappingNode: InputMaterialConnection<"point">,
    interpolation: "Linear" | "Cubic" | "Closest" | "Smart" = "Closest",
): OutputMaterialConnection<"color"> | undefined {
    const dataObject = mapAssignments.find((mapAssignment) => mapAssignment.textureType === slot)
    if (!dataObject) {
        return undefined
    }
    return materialConnection(
        new TexImage({
            parameters: {
                inputs: {vector: mappingNode},
                settings: {
                    extension: "REPEAT",
                    interpolation,
                    projection: "FLAT",
                    dataObjectLegacyId: dataObject.legacyId,
                    textureSetRevisionId: textureSetRevisionId,
                },
            },
        }),
        "color",
    )
}
